import React from 'react'
import TextField from 'material-ui/TextField';
import * as colors from "material-ui/styles/colors";

const FormText = ({ input, label, meta: { touched, error }, ...custom }) => {

  let newInput = Object.assign({}, input, {value: input.value ? input.value : ''})
  return (
  <TextField
    // hintText={label}
    floatingLabelStyle={{color: colors.grey600}}
    floatingLabelFixed
    floatingLabelText={label}
    errorText={touched && error}
    {...newInput}
    {...custom}
  />
)}

export default FormText


// WEBPACK FOOTER //
// ./src/components/FormText.js